import { render } from "./List.vue?vue&type=template&id=451526d1&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=451526d1&lang=scss"
import "./List.vue?vue&type=style&index=1&id=451526d1&lang=scss&scoped=true"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451526d1"]])

export default __exports__